<template>
  <div>
    <div class="container">
      <article class="message is-info">
        <div class="message-header large">
          <p>Update 24/03/2019 01:57AM</p>
          <!-- <button class="delete" aria-label="delete"></button> -->
        </div>
        <div class="message-body medium">
          <ul>
            <li>Added Player vs Opposition players. <b>Please note, this won't be affected by the gloabl filter i.e. 'Venue','Competition'... only the opponent.</b> You can also filter by lane and zone but not situation, I can add this if needs be...</li>
          </ul>
        </div>
      </article>
    </div>
    <article class="is-parent box">
    <h1 class="title has-text-centered">Season Totals</h1>
    <season-totals-menu name="faceoffs"></season-totals-menu>
     <section id="gameFilters">
      <div class="is-parent  is-vertical">
      <article class="is-child box">
        <h2 class="subtitle"><b>Filters</b></h2>
          <div class="columns">
            <div class="column is-3">
              <label class="label">Season</label>
              <div class="control">
                <div class="select">
                  <select v-model="YearSelected" @change="fetchSeasonStats">
                    <option value=2022>2022-2023</option>
                    <option value=2019>2019-2020</option>
                    <option value=2018>2018-2019</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column is-3">
              <label class="label">Competition</label>
              <div class="control">
                <div class="select">
                  <select v-model="CompetitionSelected"  @change="fetchSeasonStats">
                    <option v-for="option in CompetitionOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
              <div class="column is-4">
                <label class="label">Opponent</label>
                <div class="control">
                  <div class="select">
                    <select  v-model="OpponentSelected"  @change="fetchSeasonStats">
                      <option v-for="option in OpponentOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                    </select>
                  </div>
                </div>
            </div>
            <div class="column is-5">
              <label class="label">Venue</label>
              <div class="control">
                <div class="select">
                  <select v-model="VenueSelected"  @change="fetchSeasonStats">
                    <option v-for="option in VenueOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column is-4">
                <label class="label">Limit</label>
                <div class="control">
                  <div class="select">
                    <select v-model="LimitSelected" @change="fetchSeasonStats">
                      <option v-for="option in LimitOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                    </select>
                  </div>
                </div>
            </div>
          </div>
        </article>
      <data-table id="Filtered Games" heading="Filtered Games" v-bind:headers="FilterHeadings" v-bind:tableData="GameFilter"></data-table>
      </div>
    </section>
    </article>
   
    <section id="players">
      <div class="is-parent is-vertical">
        <article class="tile is-child box">
        <div class="container is-child" style="margin-top:5px;">
          <h1 class="title has-text-centered">Team Faceoffs</h1>
          <div v-for="stat in FaceoffsTeamTotals" v-bind:key="stat.total_taken">
            <h1 class="title  has-text-centered">Totals</h1>
            <div class="table__wrapper">
            <table class="table is-responsive is-striped is-fullwidth" style="overflow-x: auto;">
              <thead>
                <th>Taken</th>
                <th>Wins</th>
                <th>Losses</th>
                <th>Win %</th>
              </thead>
              <tbody>
                  <tr>
                    <td>{{stat.total_taken}}</td>
                    <td>{{stat.total_won}}</td>
                    <td>{{stat.total_loss}}</td>
                    <td>{{stat.total_win_percentage}}</td>
                  </tr>
              </tbody>
            </table>
            </div>
            <h1 class="title  has-text-centered">Lane</h1>
            <div class="table__wrapper">
            <table class="table is-responsive is-striped is-fullwidth" style="overflow-x: auto;">
              <thead>
                <th>Lane</th>
                <th>Taken</th>
                <th>Wins</th>
                <th>Losses</th>
                <th>Win %</th>
              </thead>
              <tbody>
                  <tr>
                    <td>Left</td>
                    <td>{{stat.left_taken}}</td>
                    <td>{{stat.left_won}}</td>
                    <td>{{stat.left_loss}}</td>
                    <td>{{stat.left_win_percentage}}</td>
                  </tr>
                  <tr>
                    <td>Center</td>
                    <td>{{stat.center_taken}}</td>
                    <td>{{stat.center_won}}</td>
                    <td>{{stat.center_loss}}</td>
                    <td>{{stat.center_win_percentage}}</td>
                  </tr>
                  <tr>
                    <td>Right</td>
                    <td>{{stat.right_taken}}</td>
                    <td>{{stat.right_won}}</td>
                    <td>{{stat.right_loss}}</td>
                    <td>{{stat.right_win_percentage}}</td>
                  </tr>
              </tbody>
            </table>
            </div>
            <h1 class="title  has-text-centered">Zone</h1>
            <div class="table__wrapper">
            <table class="table is-responsive is-striped is-fullwidth" style="overflow-x: auto;">
              <thead>
                <th>Zone</th>
                <th>Taken</th>
                <th>Wins</th>
                <th>Losses</th>
                <th>Win %</th>
              </thead>
              <tbody>
                  <tr>
                    <td>Offensive</td>
                    <td>{{stat.offensive_taken}}</td>
                    <td>{{stat.offensive_won}}</td>
                    <td>{{stat.offensive_loss}}</td>
                    <td>{{stat.offensive_win_percentage}}</td>
                  </tr>
                  <tr>
                    <td>Neutral</td>
                    <td>{{stat.neutral_taken}}</td>
                    <td>{{stat.neutral_won}}</td>
                    <td>{{stat.neutral_loss}}</td>
                    <td>{{stat.neutral_win_percentage}}</td>
                  </tr>
                  <tr>
                    <td>Defensive</td>
                    <td>{{stat.defensive_taken}}</td>
                    <td>{{stat.defensive_won}}</td>
                    <td>{{stat.defensive_loss}}</td>
                    <td>{{stat.defensive_win_percentage}}</td>
                  </tr>
              </tbody>
            </table>
            </div>
          </div>
          </div>
        </article>
        <article class="tile is-child box">
        <div class="container is-child" style="margin-top:5px;">
          <h1 class="title has-text-centered">Player Totals</h1>
          <h1 class="subtitle has-text-centered" style="color:rgba(54, 162, 235, 1);" v-if="this.OpponentSelected === 0"><b>Please select an opponent team from the global filter above</b></h1>
            <div class="table__wrapper">
            <table class="table is-responsive is-striped is-fullwidth" style="overflow-x: auto;">
              <thead>
                <th>Player</th>
                <th>GP</th>
                <th>Taken</th>
                <th>Wins</th>
                <th>Losses</th>
                <th>Win %</th>
                <th>Avg Taken / Game</th>
                <th>Avg Win / Game</th>
              </thead>
              <tbody>
                  <tr v-for="stat in FaceoffsPlayerCombo" v-bind:key="stat.player">
                    <td>{{stat.player}}</td>
                    <td>{{stat.gp}}</td>
                    <td>{{stat.fo_total_taken}}</td>
                    <td>{{stat.fo_total_win_total}}</td>
                    <td>{{stat.fo_total_loss_total}}</td>
                    <td>{{stat.fo_total_win_percent}}</td>
                    <td>{{stat.fo_total_taken_average}}</td>
                    <td>{{stat.fo_total_win_average}}</td>
                  </tr>
              </tbody>
            </table>
            </div>
            <h1 class="title  has-text-centered">Lane</h1>
            <div class="table__wrapper">
            <table class="table is-responsive is-striped is-fullwidth" style="overflow-x: auto;">
              <thead>
                <th>Player</th>
                <th>GP</th>
                <th>Left T</th>
                <th>Left W</th>
                <th>Left L</th>
                <th>Left W%</th>
                <th>Center T</th>
                <th>Center W</th>
                <th>Center L</th>
                <th>Center W%</th>
                <th>Right T</th>
                <th>Right W</th>
                <th>Right L</th>
                <th>Right W%</th>
              </thead>
              <tbody>
                  <tr v-for="stat in FaceoffsPlayerCombo" v-bind:key="stat.player">
                    <td>{{stat.player}}</td>
                    <td>{{stat.gp}}</td>
                    <td>{{stat.fo_left_taken}}</td>
                    <td>{{stat.fo_left_win_total}}</td>
                    <td>{{stat.fo_left_loss_total}}</td>
                    <td>{{stat.fo_left_win_percent}}</td>
                    <td>{{stat.fo_center_taken}}</td>
                    <td>{{stat.fo_center_win_total}}</td>
                    <td>{{stat.fo_center_loss_total}}</td>
                    <td>{{stat.fo_center_win_percent}}</td>
                    <td>{{stat.fo_right_taken}}</td>
                    <td>{{stat.fo_right_win_total}}</td>
                    <td>{{stat.fo_right_loss_total}}</td>
                    <td>{{stat.fo_right_win_percent}}</td>
                  </tr>
              </tbody>
            </table>
            </div>
            <h1 class="title  has-text-centered">Zone</h1>
            <div class="table__wrapper">
            <table class="table is-responsive is-striped is-fullwidth" style="overflow-x: auto;">
              <thead>
                <th>Player</th>
                <th>GP</th>
                <th>Offensive T</th>
                <th>Offensive W</th>
                <th>Offensive L</th>
                <th>Offensive W%</th>
                <th>Offensive W/GP%</th>
                <th>Neutral T</th>
                <th>Neutral W</th>
                <th>Neutral L</th>
                <th>Neutral W%</th>
                <th>Neutral W/GP%</th>
                <th>Defensive T</th>
                <th>Defensive W</th>
                <th>Defensive L</th>
                <th>Defensive W%</th>
                <th>Defensive W/GP%</th>
              </thead>
              <tbody>
                  <tr v-for="stat in FaceoffsPlayerCombo" v-bind:key="stat.player">
                    <td>{{stat.player}}</td>
                    <td>{{stat.gp}}</td>
                    <td>{{stat.fo_offensive_taken}}</td>
                    <td>{{stat.fo_offensive_win_total}}</td>
                    <td>{{stat.fo_offensive_loss_total}}</td>
                    <td>{{stat.fo_offensive_win_percent}}</td>
                    <td>{{stat.fo_offensive_win_average}}</td>
                    <td>{{stat.fo_neutral_taken}}</td>
                    <td>{{stat.fo_neutral_win_total}}</td>
                    <td>{{stat.fo_neutral_loss_total}}</td>
                    <td>{{stat.fo_neutral_win_percent}}</td>
                    <td>{{stat.fo_neutral_win_average}}</td>
                    <td>{{stat.fo_defensive_taken}}</td>
                    <td>{{stat.fo_defensive_win_total}}</td>
                    <td>{{stat.fo_defensive_loss_total}}</td>
                    <td>{{stat.fo_defensive_win_percent}}</td>
                    <td>{{stat.fo_defensive_win_average}}</td>
                  </tr>
              </tbody>
            </table>
            </div>
          </div>
        </article>
        <article class="tile is-child box">
        <div class="container is-child" style="margin-top:5px;">
          <h1 class="title has-text-centered">Faceoffs By Player</h1>
          <h1 class="subtitle has-text-centered" style="color:rgba(54, 162, 235, 1);" v-if="this.OpponentSelected === 0"><b>Please select an opponent team from the global filter above</b></h1>
          <div class="columns">
            <div class="column is-4">
            <label class="label">Zone</label>
            <div class="control">
              <div class="select">
                <select v-model="ZoneSelected"  @change="fetchFaceoffByPlayer">
                  <option v-for="option in ZoneOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                </select>
              </div>
            </div>
              </div>
            <div class="column is-4">
            <label class="label">Lane</label>
            <div class="control">
              <div class="select">
                <select v-model="LaneSelected"  @change="fetchFaceoffByPlayer">
                  <option v-for="option in LaneOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                </select>
              </div>
            </div>
            </div>
          </div>
          <div v-for="player in FaceoffsByPlayer" v-bind:key="player.player">
          <article class="is-child box">
            <h1 class="title  has-text-centered">{{player.player}}</h1>
            <div class="table__wrapper">
            <table class="table is-responsive is-striped is-fullwidth" style="overflow-x: auto;">
              <thead>
                <th>VS</th>
                <th>Taken</th>
                <th>Wins</th>
                <th>Losses</th>
                <th>Win %</th>
              </thead>
              <tbody>
                <tr v-for="away in player.vs" v-bind:key="away.away_player">
                  <td>{{away.away_player}}</td>
                  <td>{{away.fo_taken}}</td>
                  <td>{{away.fo_win}}</td>
                  <td>{{away.fo_loss}}</td>
                  <td>{{away.fo_win_percentage}}</td>
                </tr>

              </tbody>
            </table>
            </div>
          </article>
          </div>
          </div>
        </article>
      </div>
    </section>
  </div>
</template>
<script>
import DataTable from '../data-table'
import SubTable from '../sub-table'
import SeasonTotals from '../season-totals-menu'
import Chart from 'vue-bulma-chartjs'
import _ from 'lodash'
export default {
  components: {
    'data-table': DataTable,
    'sub-table': SubTable,
    'season-totals-menu': SeasonTotals,
    Chart
  },
  data () {
    return {
      GameFilter: [],
      CompetitionOptions: [],
      VenueOptions: [],
      OpponentOptions: [],
      SituationOptions: [],
      PeriodOptions: [],
      LimitOptions: [],
      LaneOptions: [],
      ZoneOptions: [],
      YearSelected: 2022,
      CompetitionSelected: 'EIHL_Challenge_Cup',
      VenueSelected: 0,
      OpponentSelected: 3,
      PeriodSelected: 0,
      SituationSelected: 0,
      LaneSelected: '',
      ZoneSelected: '',
      LimitSelected: 0,
      FilterSelected: 'fo_win_total',
      FaceoffsByPlayer: [],
      FaceoffsPlayerCombo: [],
      FaceoffsTeamTotals: [],
      FaceoffssPlayerData: [],
      FaceoffssPlayerHeadings: [
        'Player',
        'GP',
        'Taken',
        'Win Win',
        'Win Loss',
        'Loss Loss',
        'Loss Win',
        'Win Total',
        'Loss Total',
        'Win%',
        'Taken AVG',
        'Win AVG'
      ],
      FaceoffssPlayerFilters: [
        {text: 'Player', value: 'player'},
        {text: 'GP', value: 'gp'},
        {text: 'Taken', value: 'fo_taken'},
        {text: 'Win Win', value: 'fo_win_win_total'},
        {text: 'Win Loss', value: 'fo_win_loss'},
        {text: 'Loss Loss', value: 'fo_loss_loss'},
        {text: 'Loss Win', value: 'fo_loss_win'},
        {text: 'Win Total', value: 'fo_win_total'},
        {text: 'Loss Total', value: 'fo_loss_total'},
        {text: 'Win %', value: 'fo_win_percent'},
        {text: 'Taken AVG', value: 'fo_taken_average'},
        {text: 'Win AVG', value: 'fo_win_average'}
      ],
      bar_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,

        scales: {
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true
            }
          }]
        }
      }
    }
  },
  computed: {
    sortByFaceoffssData: function () {
      return _.orderBy(this.FaceoffssPlayerData, this.FilterSelected, ['desc'])
    },
    sortByFaceoffssDataChart: function () {
      let orderedData = this.sortByFaceoffssData
      return _.map(orderedData, this.FilterSelected)
    },
    chartData: function () {
      let playerLabels = []
      for (var label of this.sortByFaceoffssData) {
        playerLabels.push(label.player)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      data.datasets = [{
        data: this.sortByFaceoffssDataChart,
        label: 'Faceoffs - ' + this.FilterSelected,
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }]
      return data
    }
  },
  methods: {
    fetchSeasonStats () {
      let postData = {
        'year': this.YearSelected,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': this.SituationSelected,
        'lane': this.LaneSelected,
        'zone': this.ZoneSelected,
        'limit': this.LimitSelected
      }
      console.log('Filter: ' + JSON.stringify(postData))
      this.$http.post('https://devilsapi.roblutken.com/api/app/season-stats/faceoffs/team', postData, {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      }).then(
        response => {
          console.log(response.data)
          this.FaceoffsTeamTotals = response.data
        }
      )
      this.$http
        .post('https://devilsapi.roblutken.com/api/app/season-stats/faceoffs', postData, {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
        })
        .then(
          response => {
            console.log(response.data)
            this.GameFilter = response.data.games_filter
            this.FaceoffssPlayerData = response.data.faceoffs
          },
          response => {}
        )
      this.$http
        .post('https://devilsapi.roblutken.com/api/app/season-stats/faceoffs-by-player-combo', postData, {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
        })
        .then(
          response => {
            console.log(response.data)
            this.FaceoffsPlayerCombo = response.data.faceoffs_by_player_combo
          },
          response => {}
        )
    },
    fetchFaceoffByPlayer () {
      let postData = {
        'year': this.YearSelected,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': this.SituationSelected,
        'lane': this.LaneSelected,
        'zone': this.ZoneSelected,
        'limit': this.LimitSelected
      }
      this.$http
        .post('https://devilsapi.roblutken.com/api/app/season-stats/faceoffs-by-player', postData, {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
        })
        .then(
          response => {
            console.log('FO VS PLAYER' + response.data.faceoffs_by_player)
            this.FaceoffsByPlayer = response.data.faceoffs_by_player
          },
          response => {}
        )
    },
    fetchFilterOptions () {
      this.$http.get('https://devilsapi.roblutken.com/api/app/season-stats/filters/', {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(
          response => {
            // console.log(response.data)
            let venue = response.data.venue
            this.VenueOptions.push({text: 'All', value: 0})
            for (var i = 0; i < venue.length; i++) {
              this.VenueOptions.push({text: venue[i].location, value: venue[i].location})
            }
            let opponent = response.data.teams
            this.OpponentOptions.push({text: 'All', value: 0})
            for (var j = 0; j < opponent.length; j++) {
              if (opponent[j].id !== '1') {
                this.OpponentOptions.push({text: opponent[j].name, value: opponent[j].id})
              }
            }
            let situations = response.data.situations
            this.SituationOptions.push({text: 'All', value: 0})
            this.SituationOptions.push({text: 'Even Handed', value: 1})
            this.SituationOptions.push({text: 'Power Play', value: 2})
            this.SituationOptions.push({text: 'Short Handed', value: 3})
            this.SituationOptions.push({text: 'Empty Net', value: 4})
            this.SituationOptions.push({text: '-- N/A Yet - Secondary Situations--', value: -5})
            for (var s = 0; s < situations.length; s++) {
            //  this.SituationOptions.push({text: situations[s].secondary_situation, value: situations[s].id})
            }
            this.CompetitionOptions.push({text: 'All', value: 0})
            this.CompetitionOptions.push({text: 'EIHL & Challenge Cup', value: 'EIHL_Challenge_Cup'})
            this.CompetitionOptions.push({text: 'EIHL', value: 'EIHL'})
            this.CompetitionOptions.push({text: 'Challenge Cup', value: 'Challenge-Cup'})
            this.CompetitionOptions.push({text: 'Pre-Season', value: 'Pre-Season'})
            this.CompetitionOptions.push({text: 'Playoffs', value: 'Playoffs'})
            this.CompetitionOptions.push({text: 'CHL', value: 'CHL'})

            this.PeriodOptions.push({text: 'All', value: 0})
            this.PeriodOptions.push({text: 'Period 1', value: 1})
            this.PeriodOptions.push({text: 'Period 2', value: 2})
            this.PeriodOptions.push({text: 'Period 3', value: 3})
            this.PeriodOptions.push({text: 'Period OT', value: 4})
            this.PeriodOptions.push({text: 'Period Shootout', value: 5})

            this.LimitOptions.push({text: 'All', value: 0})
            this.LimitOptions.push({text: '5 Games', value: 5})
            this.LimitOptions.push({text: '10 Games', value: 10})
            this.LimitOptions.push({text: '20 Games', value: 20})

            this.LaneOptions.push({text: 'All', value: ''})
            this.LaneOptions.push({text: 'Left', value: 'Left'})
            this.LaneOptions.push({text: 'Center', value: 'Center'})
            this.LaneOptions.push({text: 'Right', value: 'Right'})

            this.ZoneOptions.push({text: 'All', value: ''})
            this.ZoneOptions.push({text: 'Offensive', value: 'Offensive'})
            this.ZoneOptions.push({text: 'Neutral', value: 'Neutral'})
            this.ZoneOptions.push({text: 'Defensive', value: 'Defensive'})
          }
        )
    }
  },
  created () {
    this.fetchSeasonStats()
    this.fetchFaceoffByPlayer()
    this.fetchFilterOptions()
  }
}
</script>
<style>
#fixed-div {
    position: fixed;
    top: 1em;
    right: 1em;
}
</style>



// WEBPACK FOOTER //
// faceoffs.vue?c385ca76